import Toaster from "global/component/Genericos/Toaster/Toaster";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import CirculoTildeOk from "_+_Portal/assets/images/generico/CirculoTildeOk";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { wsPostFilaVirtual } from "_+_Portal/_-_Autocheckin/context/action/filaVirtual";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";

import {
  ContainerFilaVirtualCasa,
  FilaVirtualCasaBotones,
  FilaVirtualCasaConoceMasTxt,
  FilaVirtualCasaIcono,
  FilaVirtualCasaTitulo,
  FilaVirtualCasaTxt,
} from "./localStyle";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import { getLocalStorage } from "global/utils/safeJsonParse";

const FilaVirtualCasa = ({ setError, turnoActual }) => {
  // -------------------------  useContex  ----------------------------
  const {
    turnosAutoCheckInState,
    pasoDispatch,
    turnosSeleccionadosState,
    filaVirtualDispatch,
    filaVirtualState,
  } = useContext(AutocheckContext);
  const { toasterState, authState } = useContext(GlobalContext);

  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  let idTerminal = getLocalStorage("idTerminal");

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
  const turno = listTurnosSeleccionado[turnoActual];
  const medico = turno?.medico;
  const especialidad = turno?.especialidad;

  let initialData = turnosAutoCheckInState.turnosAutoCheckIn?.data;
  if (initialData !== false && Array.isArray(initialData)) {
    initialData = initialData.filter((e) => !e.presente);
  }

  // -------------------------  constants  ----------------------------

  // -------------------------  funciones  ----------------------------
  const volver = () => {
    setPaso("Home")(pasoDispatch);
  };
  const handleClickMasInfo = () => {
    setPaso("FilaVirtualMasInfoCasa")(pasoDispatch);
  };

  const irATurnos = () => {
    if (idTerminal) {
      setPaso("TurnosRecepcionados")(pasoDispatch);
    } else {
      setPaso("TurnosRecepcionadosQR")(pasoDispatch);
    }
  };

  const callBack = (isCorrect) => {
    if (isCorrect) {
      // setPaso("TurnosRecepcionados")(pasoDispatch);
    }
  };

  const ingresarFilaVirtual = () => {
    let dtoFilaVirtual = {
      idpaciente: authState.auth?.data?.paciente?.codigo,
      idturno: turno?.idturno,
      demorainicial: 0,
    };
    wsPostFilaVirtual(dtoFilaVirtual, (isCorrect) => callBack(isCorrect))(
      filaVirtualDispatch
    );
  };

  // -------------------------  funciones  ----------------------------

  useEffect(() => {
    if (filaVirtualState.filaVirtual.data === null) {
      ingresarFilaVirtual();
    }
  }, []);

  return (
    <LayoutPasos handleClick={volver} type={"no-circle"} title={"FILA VIRTUAL"}>
      {toasterState.toaster.show && <ToasterV2 />}
      <ContainerFilaVirtualCasa>
        <CardBlueHeart
          medico={medico ? medico : especialidad}
          turnoTitle={especialidad}
          pasoActual={turnoActual + 1}
          pasoTotal={listTurnosSeleccionado.length}
        />
        <FilaVirtualCasaTitulo>
          <span className="rb24b">¡Terminamos!</span>
          <span className="rb18l">Ya recepcionaste tu turno</span>
        </FilaVirtualCasaTitulo>
        <FilaVirtualCasaIcono>
          <CirculoTildeOk width={90} height={90} />
        </FilaVirtualCasaIcono>

        <FilaVirtualCasaTxt>
          <span className="rb18l">
            Te ingresamos en la <span className="rb18b"> fila virtual.</span> Te
            avisaremos cuando se acerque el horario de atención
          </span>
        </FilaVirtualCasaTxt>
        <FilaVirtualCasaConoceMasTxt>
          <span
            onClick={handleClickMasInfo}
            className="FilaVirtualCasaConoceMasTxt rb18b"
          >
            Toca acá para conocer más
          </span>
        </FilaVirtualCasaConoceMasTxt>
        <FilaVirtualCasaBotones>
          <div className="btn bgc-broccoli c-white" onClick={irATurnos}>
            Ir a turnos
          </div>
        </FilaVirtualCasaBotones>
      </ContainerFilaVirtualCasa>
    </LayoutPasos>
  );
};

export default FilaVirtualCasa;
